<template>
	<div class="factoring">
		<v-switch
				class="switchFrozen"
				v-model="isFactoring"
				@change="onSwitch"
				label="Factoring"
				color="success"
				hide-details
		></v-switch>
		<div v-if="isFactoring">
			<div class="groupField_wrap">
				<field
						:classError="valid.factoring_name.$error"
						margin="10px 10px 0 0"
						width="260px"
						label="Factoring company"
						placeholder="Enter factoring company"
						@updateAutocomplete="onManagerAutocomplete"
						:autocompleteValue="{value: factoringList.factoring_name, id: factoringList.factoring_id}"
						:items="factoringData"
						is-autocomplete
						is-required
				></field>
				<field
						margin="10px 10px 0 0"
						width="260px"
						label="Manager’s name"
						placeholder="Enter manager’s name"
						@updateInput="onInput($event, 'factoring_manager')"
						:setInputValue="factoringList.factoring_manager"
				></field>
				<field
						margin="10px 10px 0 0"
						width="260px"
						type="number"
						label="Manager’s phone"
						placeholder="Enter manager’s phone"
						@updateInput="onInput($event, 'factoring_phone')"
						:setInputValue="factoringList.factoring_phone"
				></field>
				<field
						margin="10px 10px 0 0"
						width="260px"
						label="Manager’s email"
						placeholder="Enter manager’s email"
						@updateInput="onInput($event, 'factoring_address')"
						:setInputValue="factoringList.factoring_address"
				></field>
			</div>
			<div class="groupFieldWrapper">
				<div class="groupFieldWrapper_title">Account</div>
				<div class="groupField_wrap">
					<field
							margin="10px 10px 0 0"
							width="260px"
							label="Account name"
							placeholder="Enter account name"
							@updateInput="onInput($event, 'factoring_account')"
							:setInputValue="factoringList.factoring_account"
					></field>
					<field
							:classError="valid.factoring_url.$error"
							margin="10px 10px 0 0"
							width="260px"
							label="URL"
							placeholder="Enter URL"
							@updateInput="onInput($event, 'factoring_url')"
							:setInputValue="factoringList.factoring_url"
							is-clip
							is-link
					></field>
					<field
							margin="10px 10px 0 0"
							width="260px"
							label="Login"
							placeholder="Enter login"
							@updateInput="onInput($event, 'factoring_login')"
							:setInputValue="factoringList.factoring_login"
							is-clip
					></field>
					<field
							margin="10px 10px 0 0"
							width="260px"
							type="password"
							label="Password"
							placeholder="Enter Password"
							@updateInput="onInput($event, 'factoring_password')"
							:setInputValue="factoringList.factoring_password"
							is-clip
							is-pass
					></field>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Factoring",
	computed: mapGetters([ 'customersList' ]),
	props: {
		valid: Object,
		factoringSwitcher: Boolean,
	},
	data: () => ({
		isFactoring: false,
		factoringData: [],
		factoringList: {
			factoring_name: null,
			factoring_manager: null,
			factoring_phone: null,
			factoring_address: null,
			factoring_account: null,
			factoring_login: null,
			factoring_password: null,
			factoring_url: null,
			factoring_id: null
		}
	}),
	methods: {
		getData() {
			this.$emit('updateFactoring', { ...this.$data });
		},
		onSwitch() {
			this.getData();
		},
		onInput({ value }, key) {
			this.factoringList[key] = value;
			this.getData();
		},
		onManagerAutocomplete({ value }) {
			this.factoringList.factoring_name = value?.value;
			this.factoringList.factoring_id = value?.id;
			this.getData();
		},
	},
	mounted() {
		const { factoring, customers } = this.customersList;
		const {
			factoring_name,
			factoring_manager,
			factoring_phone,
			factoring_address,
			factoring_account,
			factoring_login,
			factoring_password,
			factoring_url,
			factoring_id
		} = customers;

		this.factoringList = {
			factoring_manager,
			factoring_phone,
			factoring_address,
			factoring_account,
			factoring_login,
			factoring_password,
			factoring_url,
			factoring_name,
			factoring_id
		};

		/*		const factoringValue = this.factoringData.find(item => item.value === factoring_name);
				this.factoringList.factoring_name = factoringValue?.value || null;
				this.factoringList.factoring_id = factoringValue?.id || null;*/

		this.factoringData = factoring;
		this.isFactoring = this.factoringSwitcher;
	}
};
</script>

<style scoped lang="scss">
@import "Factoring";
</style>
